import PropTypes from "prop-types";

export const ContactFormImagesPropTypes = {
  section_title: PropTypes.string,
  new_project_title: PropTypes.string,
  new_front_img: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    mime_type: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  new_back_img: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    mime_type: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),

  join_team_title: PropTypes.string,
  join_front_img: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    mime_type: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  join_back_img: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    mime_type: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),

  general_form_title: PropTypes.string,
  general_front_image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    mime_type: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
  general_back_image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
    title: PropTypes.string,
    mime_type: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
  }),
};
